import { useWallet } from "@manahippo/aptos-wallet-adapter";
import React, { useEffect, useState } from "react";

import Button from "../../components/Common/Button";
import Card from "../../components/Common/Card";
import TransactionDialog from "../../components/Common/TransactionDialog";
import Divider from "../../components/Divider";
import LoginWallet from "../../components/LoginWallet";
import SwapInCard from "../../components/Swap/SwapInCard";
import SwapIcon from "../../imgs/swap.svg";
import { getTransactionByHash } from "../../libs/aptos_sdk";
import coins from "../../libs/coins/coins.json";
import { getCoinInfo, CoinInfo } from "../../libs/pool";
import { add_liquidity } from "../../libs/swap_sdk";
import { sleep } from "../../utils/common";

export default function CreateLiquidity() {
  const { signAndSubmitTransaction, account } = useWallet();

  const [xCoin, setXCoin] = useState<string>(coins[0].address);
  const [yCoin, setYCoin] = useState<string>(coins[1].address);
  const [xAmount, setXAmount] = useState("0");
  const [yAmount, setYAmount] = useState("0");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [step, setStep] = useState<number>(0);
  const [txn, setTxn] = useState<string>("");
  const [createPoolBtnDisable, setCreatePoolBtnDisable] =
    useState<boolean>(true);
  const [createPoolBtnText, setCreatePoolBtnText] =
    useState<string>("Enter an amount");

  const [xCoinInfo, setXCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [yCoinInfo, setYCoinInfo] = useState<CoinInfo | undefined>(undefined);

  useEffect(() => {
    getCoinInfo(xCoin).then((res: CoinInfo) => {
      setXCoinInfo(res);
    });
  }, [xCoin]);

  useEffect(() => {
    getCoinInfo(yCoin).then((res: CoinInfo) => {
      setYCoinInfo(res);
    });
  }, [yCoin]);

  const xRef = React.createRef();
  const yRef = React.createRef();

  useEffect(() => {
    if (xRef && xRef.current && yRef && yRef.current) {
      const balanceX = (xRef.current as any).balance;
      const balanceY = (yRef.current as any).balance;

      if (Number(xAmount) > Number(balanceX)) {
        setCreatePoolBtnDisable(true);
        setCreatePoolBtnText("Insufficient in coin balance");
        return;
      }
      if (Number(yAmount) > Number(balanceY)) {
        setCreatePoolBtnDisable(true);
        setCreatePoolBtnText("Insufficient in coin balance");
        return;
      }
      if (Number(xAmount) > 0 && Number(yAmount) > 0) {
        setCreatePoolBtnDisable(false);
        setCreatePoolBtnText("Create Pair");
        return;
      }
      setCreatePoolBtnDisable(true);
      setCreatePoolBtnText("Enter an amount");
    }
  }, [xAmount, xRef, yAmount, yRef]);

  const handle_create_liquidity = async () => {
    setTxn("");
    setOpenAlert(true);
    setStep(0);
    const xAmount1 = parseInt(
      (Number(xAmount) * Math.pow(10, xCoinInfo?.decimals!)).toFixed(0),
      10
    );
    const yAmount1 = parseInt(
      (Number(yAmount) * Math.pow(10, yCoinInfo?.decimals!)).toFixed(0),
      10
    );

    const data = await add_liquidity(
      signAndSubmitTransaction,
      xCoin,
      yCoin,
      xAmount1,
      yAmount1,
      xAmount1,
      yAmount1
    );

    setTxn(data.hash);

    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
      } catch {
        await sleep(500);
      }
    }
    setStep(2);
  };

  const handle_x_amount = async (v: any) => {
    setXAmount(v);
  };

  const handle_y_amount = async (v: any) => {
    setYAmount(v);
  };

  const handleCloseAlert = () => setOpenAlert(false);

  return (
    <div className="overflow-auto no-scrollbar flex items-center justify-center h-screen">
      <div className="flex flex-col w-1/3 max-xl:w-3/4 max-sm:w-full max-sm:px-2">
        <Card>
          <div className="flex justify-between items-center py-4 px-4">
            <div className="text-white text-xl font-normal">Create Pool</div>
          </div>
          <div className="p-2 content-center">
            <div className="w-full">
              <SwapInCard
                inCoin={xCoin}
                changeCoin={setXCoin}
                changeAmount={handle_x_amount}
                onRef={xRef}
              />
              <Divider>
                <div className="border-white border-opacity-25 border-2 bg-primary-200 rounded-2xl">
                  <img src={SwapIcon} alt="" />
                </div>
              </Divider>
              <SwapInCard
                inCoin={yCoin}
                changeCoin={setYCoin}
                changeAmount={handle_y_amount}
                onRef={yRef}
              />
            </div>
          </div>
        </Card>

        <div className="mt-1 p-1">
          {account ? (
            <Button
              disabled={createPoolBtnDisable}
              onClick={handle_create_liquidity}
              variant="contained"
              fullWidth
            >
              {createPoolBtnText}
            </Button>
          ) : (
            <LoginWallet local={1} />
          )}
        </div>
      </div>

      <div>
        {!!xCoinInfo && !!yCoinInfo && (
          <TransactionDialog
            openAlert={openAlert}
            txn={txn}
            title={`Create Pair  ${xAmount}  ${
              xCoinInfo!.symbol
            } and ${yAmount}  ${yCoinInfo!.symbol}`}
            step={step}
            handleCloseAlert={handleCloseAlert}
          />
        )}
      </div>
    </div>
  );
}
